import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const AdminMissionVisionSection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [mvSectionDetails, setmvSectionDetails] = useState(null);
    const [message, setMessage] = useState("");

    const [form, setForm] = useState({
        mission_content: "",
        vission_content: "",
    });

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchMVSection();
    }, []);

    const fetchMVSection = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/about_page/get_mission_vission_section/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                setmvSectionDetails(res.data.data);

                // ✅ Populate form AFTER API response
                setForm({
                    mission_content: res.data.data.mission_content || "",
                    vission_content: res.data.data.vission_content || "",
                });

            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- Input Change ---------------- */
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    /* ---------------- Submit ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("mission_content", form.mission_content);
            formData.append("vission_content", form.vission_content);

            const res = await axios.post(
                `${baseAPIUrl}admin/about_page/add_edit_mission_vission_section`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            setMessage(res.data.msg);
            fetchMVSection();
            scrollToTop();
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Mission & Vision section</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Mission & Vision section</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <h4>Edit Mission & Vission section</h4>
                                </div>
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div class="card-body">
                                        {message && (
                                            <p className="text-center text-danger">{message}</p>
                                        )}
                                        {/* Mission Points */}
                                        <div className="form-group">
                                            <label>Mission Points (one point per line)</label>
                                            <textarea
                                                name="mission_content"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`• Quality education\n• Holistic development\n• Value-based learning`}
                                                value={form.mission_content}
                                                onChange={handleChange}
                                            />
                                            <small className="text-muted">
                                                Enter one bullet point per line
                                            </small>
                                        </div>

                                        {/* Vision Points */}
                                        <div className="form-group">
                                            <label>Vission Points (one point per line)</label>
                                            <textarea
                                                name="vission_content"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`• Quality education\n• Holistic development\n• Value-based learning`}
                                                value={form.vission_content}
                                                onChange={handleChange}
                                            />
                                            <small className="text-muted">
                                                Enter one bullet point per line
                                            </small>
                                        </div>
                                    </div>

                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}
export default AdminMissionVisionSection;